"use client";

import { type FinishEnum, type GameCard } from "modules/cards/model/card";
import { CardImageText } from "modules/common/components/CardDetailsDialog/CardImageText";
import { CardDetailsLegalities } from "modules/common/components/CardDetailsDialog/CardDetailsLegalities";
import { CardDetailsPrintings } from "modules/common/components/CardDetailsDialog/CardDetailsPrintings";
import CardRulings from "modules/common/components/CardDetailsDialog/CardDetailsRulings";
import { ResponsiveCardSizing } from "utils/styles";

interface CardDetailsContentProps {
  displayCard: GameCard;
  finish?: FinishEnum;
}

export function CardDetailsContent({
  displayCard,
  finish,
}: CardDetailsContentProps) {
  return (
    <div className="space-y-6">
      <CardImageText
        card={displayCard}
        isDialog={true}
        sizing={ResponsiveCardSizing}
        finish={finish}
        isPriority={false}
      />
      <CardDetailsPrintings
        card={displayCard}
        className="md:min-h-auto px-0 md:mb-0"
      />

      <CardDetailsLegalities
        game={displayCard.game}
        isDialog={true}
        legalities={displayCard.legalities}
      />
      <CardRulings card={displayCard} />
    </div>
  );
}
